export const HUNDRED_PERCENT = 100;
export const RADIAN = Math.PI / 180;
